export function sumItemAmounts(items: any[], key: string): number {
  return items.reduce((currAmount, prevItem) => currAmount + prevItem[key], 0);
}